<div class="tree-page">
  <div class="tree-header">
    <div class="titleBox">
      <h1>Employee Tree</h1>
      <p class="subtitle">
        View the reporting hierarchy. Use the search and region filters to find
        employees.
      </p>
    </div>

    <div class="tree-controls">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search by name or initials</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          placeholder="e.g. Jacob or JB"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="region-field">
        <mat-label>Region</mat-label>
        <mat-select
          [(ngModel)]="regionFilter"
          (selectionChange)="onRegionChange()"
          panelClass="employee-tree-panel"
        >
          <mat-option value="">All regions</mat-option>
          <mat-option *ngFor="let r of availableRegions" [value]="r">{{
            r
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-stroked-button
        class="action-btn"
        (click)="clearFilters()"
        [disabled]="!searchTerm && !regionFilter"
      >
        Clear Filters
      </button>
      <button mat-stroked-button class="action-btn" (click)="expandAll()">
        Expand All
      </button>
      <button mat-stroked-button class="action-btn" (click)="collapseAll()">
        Collapse All
      </button>
      <button
        mat-icon-button
        class="scroll-btn"
        (click)="scrollTree('left')"
        matTooltip="Scroll left"
      >
        <span class="scroll-arrow">&larr;</span>
      </button>
      <button
        mat-icon-button
        class="scroll-btn"
        (click)="scrollTree('right')"
        matTooltip="Scroll right"
      >
        <span class="scroll-arrow">&rarr;</span>
      </button>
      <a routerLink="/employees" class="back-link">&larr; Back to Employees</a>
    </div>
  </div>

  <div class="tree-loading" *ngIf="isLoading">
    <div class="lds-ripple"><div></div><div></div></div>
    <div>Loading employee hierarchy...</div>
  </div>

  <div
    class="tree-empty"
    *ngIf="!isLoading && filteredRoots.length === 0"
  >
    No employees to display.
  </div>

  <div
    class="match-banner"
    *ngIf="!isLoading && (searchTerm || regionFilter) && matchCount > 0"
  >
    <strong>{{ matchCount }}</strong> match{{ matchCount === 1 ? "" : "es" }}
    highlighted. The tree is narrowed to matching employees and their reporting
    chains.
  </div>

  <div
    class="match-banner no-match"
    *ngIf="!isLoading && (searchTerm || regionFilter) && matchCount === 0 && filteredRoots.length > 0"
  >
    No employees match the current filters.
  </div>

  <div class="tree-container" *ngIf="!isLoading && filteredRoots.length > 0">
    <ul class="tree-root">
      <li *ngFor="let root of filteredRoots" class="tree-item">
        <ng-container
          *ngTemplateOutlet="nodeTemplate; context: { $implicit: root, depth: 0 }"
        ></ng-container>
      </li>
    </ul>
  </div>
</div>

<ng-template #nodeTemplate let-node let-depth="depth">
  <div class="node-wrapper">
    <div
      class="employee-card"
      [class.has-children]="node.children.length > 0"
      [class.matched]="node.matched"
      [attr.data-depth]="depth"
      [id]="'node-' + node.employee_id"
    >
      <div
        class="toggle-btn"
        *ngIf="node.children.length > 0"
        (click)="toggleNode(node); $event.stopPropagation()"
        [title]="node.expanded ? 'Collapse' : 'Expand'"
      >
        <fa-icon *ngIf="node.expanded" [icon]="faChevronDown"></fa-icon>
        <fa-icon *ngIf="!node.expanded" [icon]="faChevronRight"></fa-icon>
      </div>
      <div class="toggle-spacer" *ngIf="node.children.length === 0"></div>

      <div class="employee-info">
        <div class="employee-name">{{ node.employee_name }}</div>
        <div class="employee-meta">
          <span class="region-chip" *ngIf="node.region">{{ node.region }}</span>
          <span class="type-chip" *ngIf="node.employeetype">{{
            node.employeetype
          }}</span>
          <span class="report-count" *ngIf="node.descendantCount > 0">
            {{ node.descendantCount }} report{{
              node.descendantCount === 1 ? "" : "s"
            }}
          </span>
        </div>
      </div>
    </div>

    <ul
      class="tree-children"
      *ngIf="node.expanded && node.children.length > 0"
    >
      <li *ngFor="let child of node.children" class="tree-item">
        <ng-container
          *ngTemplateOutlet="
            nodeTemplate;
            context: { $implicit: child, depth: depth + 1 }
          "
        ></ng-container>
      </li>
    </ul>
  </div>
</ng-template>
